import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;

    .job-meta-row {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        gap: 0.6em 1em;
        padding-top: 1em;
        font-size: 0.85em;
        color: ${variables.colorTextLight};

        .job-source-link {
            color: ${variables.colorContrast};
            text-decoration: underline;
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        .layout-container {
            max-width: 100%;
            width: 100%;
        }
    }
`;